import { SurveyAnswer } from "./SurveyAnswer";
import { SurveySource } from "./SurveySource";
import { SurveyScoring } from "./SurveyScoring";

export class SurveyQuestion {
    dayOffset: number;
    source: SurveySource;
    questionId: string;
    answers: SurveyAnswer[] = [];
    declined: boolean;
    scoring: SurveyScoring = null;

    public constructor(public dateTime: string = new Date().toISOString()) {
    }
 }
